// import React, { useState, useEffect, useContext, useRef } from "react";
// import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useNavigate } from "react-router-dom";
// import CheckoutContext from "../contexts/CheckoutContext";
// import ProductsResume from "../components/ProductsResume";
// import DateResume from "../components/DateResume";
// import axios from "axios";

// const NAME_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]+$/;
// const PN_REGEX = /^[0-9]{9}$/;
// const LN_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]+$/;
// const EMAIL_REGEX = /^[a-zA-Z0-9\.]+@[a-zA-Z0-9]+\.[A-Za-z]+$/



// function ClientDataForm () {

//     const formRef = useRef(null);

//     const navigate = useNavigate();

//     const { items, deliveryDate, setClientData } = useContext(CheckoutContext);

//     const [name, setName] = useState("");
//     const [validName, setValidName] = useState(false);
//     const [nameFocus, setNameFocus] = useState(false);

//     const [lastName, setLastName] = useState("");
//     const [validLastName, setValidLastName] = useState(false);
//     const [lastNameFocus, setLastNameFocus] = useState(false);

//     const [phoneNumber, setPhoneNumber] = useState("");
//     const [validPhoneNumber, setValidPhoneNumber] = useState(false);
//     const [phoneNumberFocus, setPhoneNumberFocus] = useState(false);

//     const [email, setEmail] = useState("");
//     const [validEmail, setValidEmail] = useState(false);
//     const [emailFocus, setEmailFocus] = useState(false);

//     const [errMsg, setErrMsg] = useState("");

//     //variable de estado default value
//     const [emailDefault, setEmailDefault] = useState("");
//     const [nameDefault, setNameDefault] = useState("");
//     const [lastNameDefault, setLastNameDefault] = useState("");

//     useEffect(() => {
//         if (items.length === 0 || deliveryDate.length !== 4) {
//             navigate("/");
//         }
//         formRef.current.scrollIntoView({ behavior: 'smooth' });
//     } ,[]);


//     async function handleClickContinue (e) {
//         e.preventDefault();
//         // if button enabled with JS hack
//         const v1 = NAME_REGEX.test(name);
//         const v2 = LN_REGEX.test(lastName);
//         const v3 = PN_REGEX.test(phoneNumber);
//         const v4 = EMAIL_REGEX.test(email);
//         if (!v1 || !v2 || !v3 || !v4) {
//             setErrMsg("Invalid Entry");
//             return;
//         }

//         const data = {
//             name,
//             lastName,
//             phoneNumber,
//             email
//         };

//         setClientData(data);
//         //se guardo correctamente su correo para autocompletarse en proximas entregas
//         alert("Sus datos de correo electrónico y direcciones de despacho se guardarán para agilizar futuras compras.");
//         navigate("/delivery");
//     };

//     useEffect(() => {
//         const result = NAME_REGEX.test(name);
//         setValidName(result);
//     }, [name]);

//     useEffect(() => {
//         const result = LN_REGEX.test(lastName);
//         setValidLastName(result);
//     }, [lastName]);

//     useEffect(() => {
//         const result = PN_REGEX.test(phoneNumber);
//         setValidPhoneNumber(result);
//     }, [phoneNumber]);

//     useEffect(() => {
//         const result = EMAIL_REGEX.test(email);
//         setValidEmail(result);
//     }, [email]);

//     useEffect(() => {
//         setErrMsg('');
//     }, [name, lastName, phoneNumber, email]);


//     //nuevo use effect para autocompletar el mail
//     useEffect(() => {
//         if (validPhoneNumber) {
//             //revisamos en los purchases si el numero de telefono ya esta y sacamos el mail de este
//             async function searchEmail() {
//                 try {
//                     const response = await axios.get(`${process.env.REACT_APP_API_URL}purchase/${phoneNumber}/email`);
//                     if (response.data.length > 0) {
//                         setEmailDefault(response.data[0].buyerEmail);
//                         setEmail(response.data[0].buyerEmail);
//                         setNameDefault(response.data[0].buyerName);
//                         setName(response.data[0].buyerName);
//                         setLastNameDefault(response.data[0].buyerLastName);
//                         setLastName(response.data[0].buyerLastName);
//                     }
//                 } catch (error) {
//                     console.log(error);
//                 }
//             }
//             searchEmail();
//         }
//     }, [validPhoneNumber]);

//     return(
//         <div>
//             <div className="mt-4 flex flex-col gap-2">
//                 <div>
//                     <ProductsResume items={items}/>
//                 </div>
//                 <div>
//                     <DateResume deliveryDate={deliveryDate}/>
//                 </div>
//             </div>
//             <div className="flex justify-center mb-4 pb-4">
//                 <div className="content-center px-8 py-6 text-left bg-white shadow-lg md:w-1/3 lg:w-1/3 sm:w-1/3 flex flex-col gap-4 mx-2 shadow-xl mt-4" ref={formRef}>
//                     <p className={errMsg ? "bg-red-600 pl-4 rounded-lg" : "hidden"} aria-live="assertive">{errMsg}</p>
//                     <p className="text-center text-3xl font-bold text-gray-600">Datos Personales</p>
//                     <form onSubmit={handleClickContinue} className="flex flex-col justify-evenly grow pb-4">

//                     <label htmlFor="phonenumber">
//                             Número celular:
//                             <span className={validPhoneNumber ? "ml-2 text-green-600" : "hidden"}>
//                                 <FontAwesomeIcon icon={faCheck} />
//                             </span>
//                             <span className={validPhoneNumber || !phoneNumber ? "hidden" : "ml-2 text-red-600"}>
//                                 <FontAwesomeIcon icon={faTimes} />
//                             </span>
//                         </label>
//                         <div className="flex w-full">
//                             <p className="mr-1">+56</p>
//                             <input
//                                 className="bg-gray-300 rounded-lg pl-2 mb-2 w-full"
//                                 type="tel"
//                                 id="number"
//                                 autoComplete="off"
//                                 onChange={(e) => setPhoneNumber(e.target.value)}
//                                 required
//                                 aria-invalid={validPhoneNumber ? "false" : "true"}
//                                 aria-describedby="numbernote"
//                                 onFocus={() => setPhoneNumberFocus(true)}
//                                 onBlur={() => setPhoneNumberFocus(false)}
//                             />
//                         </div>
//                         <p id="numbernote" className={phoneNumberFocus && phoneNumber &&
//                             !validPhoneNumber ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                                 <FontAwesomeIcon icon={faInfoCircle} />
//                                 El número calular debe tener un formato válido.
//                         </p>

//                         <label htmlFor="name">
//                             Nombre:
//                             <span className={validName ? "ml-2 text-green-600" : "hidden"}>
//                                 <FontAwesomeIcon icon={faCheck} />
//                             </span>
//                             <span className={validName || !name ? "hidden" : "ml-2 text-red-600"}>
//                                 <FontAwesomeIcon icon={faTimes} />
//                             </span>
//                         </label>
//                         <input
//                             className="bg-gray-300 rounded-lg pl-2 mb-2"
//                             type="text"
//                             id="name"
//                             autoComplete="given-name"
//                             onChange={(e) => setName(e.target.value)}
//                             required
//                             aria-invalid={validName ? "false" : "true"}
//                             aria-describedby="cityName"
//                             defaultValue={nameDefault}
//                             onFocus={() => setNameFocus(true)}
//                             onBlur={() => setNameFocus(false)}
//                         />
//                         <p id="cityName" className={nameFocus && name &&
//                             !validName ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                                 <FontAwesomeIcon icon={faInfoCircle} />
//                                 El nombre debe tener un formato válido.
//                         </p>
                        
//                         <label htmlFor="lastname">
//                             Apellido:
//                             <span className={validLastName ? "ml-2 text-green-600" : "hidden"}>
//                                 <FontAwesomeIcon icon={faCheck} />
//                             </span>
//                             <span className={validLastName || !lastName ? "hidden" : "ml-2 text-red-600"}>
//                                 <FontAwesomeIcon icon={faTimes} />
//                             </span>
//                         </label>
//                         <input
//                             className="bg-gray-300 rounded-lg pl-2 mb-2"
//                             type="text"
//                             id="lastname"
//                             autoComplete="family-name"
//                             onChange={(e) => setLastName(e.target.value)}
//                             required
//                             aria-invalid={validLastName ? "false" : "true"}
//                             aria-describedby="lastnameNote"
//                             defaultValue={lastNameDefault}
//                             onFocus={() => setLastNameFocus(true)}
//                             onBlur={() => setLastNameFocus(false)}
//                         />
//                         <p id="lastnameNote" className={lastNameFocus && lastName &&
//                             !validLastName ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                                 <FontAwesomeIcon icon={faInfoCircle} />
//                                 El apellido debe tener un formato válido.
//                         </p>

//                         <label htmlFor="email">
//                             Correo electrónico:
//                             <span className={validEmail ? "ml-2 text-green-600" : "hidden"}>
//                                 <FontAwesomeIcon icon={faCheck} />
//                             </span>
//                             <span className={validEmail || !email ? "hidden" : "ml-2 text-red-600"}>
//                                 <FontAwesomeIcon icon={faTimes} />
//                             </span>
//                         </label>
//                         <input
//                             className="bg-gray-300 rounded-lg pl-2 mb-2"
//                             type="text"
//                             id="email"
//                             autoComplete="email"
//                             onChange={(e) => setEmail(e.target.value)}
//                             required
//                             aria-invalid={validEmail ? "false" : "true"}
//                             aria-describedby="emailnote"
//                             defaultValue={emailDefault}
//                             onFocus={() => setEmailFocus(true)}
//                             onBlur={() => setEmailFocus(false)}
//                         />
//                         <p id="emailnote" className={emailFocus && email &&
//                             !validEmail ? "text-xs rounded-lg bg-red-300 p-1 relative" : "hidden"}>
//                                 <FontAwesomeIcon icon={faInfoCircle} />
//                                 El correo electrónico debe tener un formato válido.
//                         </p>

//                         <div className="text-center text-white font-bold mt-5">
//                             <input type="submit" disabled={ !validName || !validLastName || !validPhoneNumber || !validEmail } className="bg-gray-700 hover:bg-gray-900 w-full h-10 disabled:bg-gray-300" value="CONTINUAR" />
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ClientDataForm;

import React, { useState, useEffect, useContext, useRef } from "react";
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import CheckoutContext from "../contexts/CheckoutContext";
import ProductsResume from "../components/ProductsResume";
import DateResume from "../components/DateResume";
import MainTitle from "../components/MainTitle";
import axios from "axios";

const NAME_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]+$/;
const PN_REGEX = /^[0-9]{9}$/;
const LN_REGEX = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ_ ]+$/;
const EMAIL_REGEX = /^[a-zA-Z0-9\.]+@[a-zA-Z0-9]+\.[A-Za-z]+$/;

const inputClass = (valid, value, touched) => [
    "w-full px-3 py-2.5 rounded-xl border bg-white outline-none transition-all text-[16px] text-[#2a1419]",
    touched && value && !valid
        ? "border-red-300 focus:border-red-400 focus:ring-2 focus:ring-red-100"
        : valid
            ? "border-[#a02338] focus:border-[#a02338] focus:ring-2 focus:ring-[#fbedef]"
            : "border-gray-200 focus:border-[#a02338] focus:ring-2 focus:ring-[#fbedef]",
].join(" ");

function Field({ label, id, valid, value, focus, touched, note, children }) {
    return (
        <div className="flex flex-col gap-1">
            <div className="flex items-center gap-1.5">
                <label htmlFor={id} className="text-[13px] font-medium text-[#2a1419]">
                    {label}
                </label>
                {valid && <FontAwesomeIcon icon={faCheck} className="text-[#a02338] text-[11px]" />}
                {touched && !valid && value && <FontAwesomeIcon icon={faTimes} className="text-red-400 text-[11px]" />}
            </div>
            {children}
            {!focus && touched && value && !valid && (
                <p className="text-[11px] text-red-500 flex items-center gap-1 mt-0.5">
                    <FontAwesomeIcon icon={faInfoCircle} />
                    {note}
                </p>
            )}
        </div>
    );
}

function ClientDataForm() {

    const formRef = useRef(null);
    const navigate = useNavigate();
    const { items, deliveryDate, setClientData } = useContext(CheckoutContext);

    const [name, setName] = useState("");
    const [validName, setValidName] = useState(false);
    const [nameFocus, setNameFocus] = useState(false);

    const [lastName, setLastName] = useState("");
    const [validLastName, setValidLastName] = useState(false);
    const [lastNameFocus, setLastNameFocus] = useState(false);

    const [phoneNumber, setPhoneNumber] = useState("");
    const [validPhoneNumber, setValidPhoneNumber] = useState(false);
    const [phoneNumberFocus, setPhoneNumberFocus] = useState(false);

    const [email, setEmail] = useState("");
    const [validEmail, setValidEmail] = useState(false);
    const [emailFocus, setEmailFocus] = useState(false);

    const [errMsg, setErrMsg] = useState("");
    const [emailDefault, setEmailDefault] = useState("");
    const [nameDefault, setNameDefault] = useState("");
    const [lastNameDefault, setLastNameDefault] = useState("");

    // touched: el usuario salió del campo al menos una vez
    const [phoneTouched, setPhoneTouched] = useState(false);
    const [nameTouched, setNameTouched] = useState(false);
    const [lastNameTouched, setLastNameTouched] = useState(false);
    const [emailTouched, setEmailTouched] = useState(false);

    useEffect(() => {
        if (items.length === 0 || deliveryDate.length !== 4) {
            navigate("/");
        }
        formRef.current.scrollIntoView({ behavior: "smooth" });
    }, []);

    async function handleClickContinue(e) {
        e.preventDefault();
        const v1 = NAME_REGEX.test(name);
        const v2 = LN_REGEX.test(lastName);
        const v3 = PN_REGEX.test(phoneNumber);
        const v4 = EMAIL_REGEX.test(email);
        if (!v1 || !v2 || !v3 || !v4) {
            setErrMsg("Revisa los datos ingresados");
            return;
        }
        setClientData({ name, lastName, phoneNumber, email });
        alert("Sus datos se guardarán para agilizar futuras compras.");
        navigate("/delivery");
    }

    useEffect(() => { setValidName(NAME_REGEX.test(name)); }, [name]);
    useEffect(() => { setValidLastName(LN_REGEX.test(lastName)); }, [lastName]);
    useEffect(() => { setValidPhoneNumber(PN_REGEX.test(phoneNumber)); }, [phoneNumber]);
    useEffect(() => { setValidEmail(EMAIL_REGEX.test(email)); }, [email]);
    useEffect(() => { setErrMsg(""); }, [name, lastName, phoneNumber, email]);

    useEffect(() => {
        if (validPhoneNumber) {
            async function searchEmail() {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_URL}purchase/${phoneNumber}/email`);
                    if (response.data.length > 0) {
                        setEmailDefault(response.data[0].buyerEmail);
                        setEmail(response.data[0].buyerEmail);
                        setNameDefault(response.data[0].buyerName);
                        setName(response.data[0].buyerName);
                        setLastNameDefault(response.data[0].buyerLastName);
                        setLastName(response.data[0].buyerLastName);
                    }
                } catch (error) {
                    console.log(error);
                }
            }
            searchEmail();
        }
    }, [validPhoneNumber]);

    const allValid = validName && validLastName && validPhoneNumber && validEmail;

    return (
        <div className="min-h-screen bg-[#f7f4ef]" ref={formRef}>

            {/* Header */}
            <MainTitle />

            {/* Resúmenes */}
            <div className="mt-4 flex flex-col gap-3 mb-4">
                <ProductsResume items={items} />
                <DateResume deliveryDate={deliveryDate} />
            </div>

            {/* Separador */}
            <div className="flex items-center gap-3 px-4 mb-4">
                <div className="flex-1 h-px bg-gray-200" />
                <span className="text-[10px] text-gray-400 font-medium tracking-widest uppercase">datos personales</span>
                <div className="flex-1 h-px bg-gray-200" />
            </div>

            {/* Formulario */}
            <div className="mx-3 mb-8">
                <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">

                    {/* Header del form */}
                    <div className="px-4 py-3 bg-[#f7f4ef] border-b border-gray-100 flex items-center gap-2">
                        <svg className="w-4 h-4 text-[#a02338]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                        </svg>
                        <p className="text-sm font-semibold text-[#2a1419]">Tus datos</p>
                    </div>

                    <form onSubmit={handleClickContinue} className="px-4 py-4 flex flex-col gap-4">

                        {/* Error global */}
                        {errMsg && (
                            <div className="bg-amber-50 border border-amber-200 rounded-xl px-3 py-2.5 flex items-center gap-2">
                                <FontAwesomeIcon icon={faInfoCircle} className="text-amber-500 text-[13px] flex-shrink-0" />
                                <p className="text-[12px] text-amber-700">{errMsg}</p>
                            </div>
                        )}

                        {/* Teléfono */}
                        <Field
                            label="Número celular"
                            id="phonenumber"
                            valid={validPhoneNumber}
                            value={phoneNumber}
                            focus={phoneNumberFocus}
                            touched={phoneTouched}
                            note="Debe tener 9 dígitos sin el +56"
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-[13px] font-medium text-gray-500 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 flex-shrink-0">
                                    +56
                                </span>
                                <input
                                    className={inputClass(validPhoneNumber, phoneNumber, phoneTouched)}
                                    type="tel"
                                    id="phonenumber"
                                    autoComplete="off"
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                    required
                                    placeholder="9XXXXXXXX"
                                    onFocus={() => setPhoneNumberFocus(true)}
                                    onBlur={() => { setPhoneNumberFocus(false); setPhoneTouched(true); }}
                                />
                            </div>
                        </Field>

                        {/* Nombre */}
                        <Field
                            label="Nombre"
                            id="name"
                            valid={validName}
                            value={name}
                            focus={nameFocus}
                            touched={nameTouched}
                            note="Solo letras, sin números ni caracteres especiales"
                        >
                            <input
                                className={inputClass(validName, name, nameTouched)}
                                type="text"
                                id="name"
                                autoComplete="given-name"
                                onChange={(e) => setName(e.target.value)}
                                required
                                placeholder="Tu nombre"
                                defaultValue={nameDefault}
                                onFocus={() => setNameFocus(true)}
                                onBlur={() => { setNameFocus(false); setNameTouched(true); }}
                            />
                        </Field>

                        {/* Apellido */}
                        <Field
                            label="Apellido"
                            id="lastname"
                            valid={validLastName}
                            value={lastName}
                            focus={lastNameFocus}
                            touched={lastNameTouched}
                            note="Solo letras, sin números ni caracteres especiales"
                        >
                            <input
                                className={inputClass(validLastName, lastName, lastNameTouched)}
                                type="text"
                                id="lastname"
                                autoComplete="family-name"
                                onChange={(e) => setLastName(e.target.value)}
                                required
                                placeholder="Tu apellido"
                                defaultValue={lastNameDefault}
                                onFocus={() => setLastNameFocus(true)}
                                onBlur={() => { setLastNameFocus(false); setLastNameTouched(true); }}
                            />
                        </Field>

                        {/* Email */}
                        <Field
                            label="Correo electrónico"
                            id="email"
                            valid={validEmail}
                            value={email}
                            focus={emailFocus}
                            touched={emailTouched}
                            note="Ingresa un correo con formato válido"
                        >
                            <input
                                className={inputClass(validEmail, email, emailTouched)}
                                type="text"
                                id="email"
                                autoComplete="email"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="correo@ejemplo.com"
                                defaultValue={emailDefault}
                                onFocus={() => setEmailFocus(true)}
                                onBlur={() => { setEmailFocus(false); setEmailTouched(true); }}
                            />
                        </Field>

                        {/* Botón */}
                        <input
                            type="submit"
                            disabled={!allValid}
                            value={allValid ? "Continuar →" : "Completa tus datos"}
                            className={`
                                w-full py-3 rounded-xl text-sm font-semibold mt-1 transition-all duration-150 cursor-pointer
                                ${!allValid
                                    ? "bg-gray-100 text-gray-300 cursor-not-allowed"
                                    : "bg-[#8c1d2f] hover:bg-[#a82a42] text-[#f5f0e8] shadow-md shadow-[#8c1d2f]/20"
                                }
                            `}
                        />
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ClientDataForm;